/** @jsxImportSource @emotion/react */

import { getLayoutData } from '@backend/layoutData';
import { isStoreCode } from '@common/typeCheckers';
import { VitafyAboutUsPage as VitafyAboutUs } from '@stories/templates/VitafyAboutUsPage/VitafyAboutUsPage';
import { setupRequests } from '@utils/helpers';
import { getChildRequestLogger } from '@utils/logger';
import Layout from 'src/components/layout';

import type { NextPageWithLayout } from '../_app';
import type { TTrustedShopsRatingResponse } from '@vitafy/storefront-api-contracts';
import type { GetServerSideProps } from 'next/types';
import type { LayoutProps } from 'src/components/layout';

setupRequests();

export const getServerSideProps: GetServerSideProps<LayoutProps, { store: string }> = async (context) => {
  const { req, params, query } = context;
  const log = getChildRequestLogger(req, params, query);

  const { store: storeCode } = params || {};

  if (!storeCode || !isStoreCode(storeCode)) {
    log.error('Invalid params: store');
    throw new Error('Invalid params: store');
  }

  try {
    const [layoutProps] = await Promise.all([
      getLayoutData({
        context,
        storeCode,
        pagePath: '/about-us',
        pageType: 'product',
        pageMeta: {
          title: 'AboutUs - Bodylab',
          metaDescription: 'AboutUs',
          metaTitle: 'AboutUs - Bodylab',
          metaKeywords: null,
          metaRobots: 'INDEX,FOLLOW'
        }
      })
    ]);

    return {
      props: {
        ...layoutProps
      }
    };
  } catch (error) {
    log.error(error);
    // Render 500 page
    throw error;
  }
};

const VitafyAboutUsPage: NextPageWithLayout<{ etrustedData?: TTrustedShopsRatingResponse | null }> = ({
  etrustedData
}) => {
  return <VitafyAboutUs etrustedData={etrustedData} />;
};

VitafyAboutUsPage.getLayout = function getLayout(page, pageProps) {
  //@ts-expect-error works fine
  return <Layout {...pageProps}>{page}</Layout>;
};

export default VitafyAboutUsPage;
